import React from 'react';
import { IIconProps } from './IIconProps';

export const StarIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 20 20"
			className={iconClass}
		>
			{title && <title>{title}</title>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				strokeWidth="2"
				strokeLinejoin="round"
				d="M9.99984 1.66663L12.5748 6.88329L18.3332 7.72496L14.1665 11.7833L15.1498 17.5166L9.99984 14.8083L4.84984 17.5166L5.83317 11.7833L1.6665 7.72496L7.42484 6.88329L9.99984 1.66663Z"
			/>
		</svg>
	);
};
